module.exports = __webpack_public_path__ + "static/media/govt-baking-course.6fcc26d0.webp";